export const INITIAL_OPTIONS = {
  closeIsVisible: true,
  overlayClass: '',
  size: 'small',
  padding: 'large',
};
